import api from "@/Plugins/axios";

export class Notification {
    async list(params = {}) {
        try {
            const response = await api.get("/notifications", { params });
            return [response, null];
        } catch (err) {
            return [null, err];
        }
    }

    async unreadCount() {
        try {
            const response = await api.get("/notifications/unread-count");
            return [response, null];
        } catch (err) {
            return [null, err];
        }
    }

    async markAsRead(id) {
        try {
            const response = await api.put(`/notifications/${id}/read`);
            return [response, null];
        } catch (err) {
            return [null, err];
        }
    }

    async markAllAsRead() {
        try {
            const response = await api.put("/notifications/mark-all-read");
            return [response, null];
        } catch (err) {
            return [null, err];
        }
    }

    async remove(id) {
        try {
            const response = await api.delete(`/notifications/${id}`);
            return [response, null];
        } catch (err) {
            return [null, err];
        }
    }

    async badgeCounts() {
        try {
            const response = await api.get("/notifications/badge-count");
            return [response, null];
        } catch (err) {
            return [null, err];
        }
    }

    async unapprovedCounts() {
        try {
            const response = await api.get("/notifications/unapproved-count");
            return [response, null];
        } catch (err) {
            return [null, err];
        }
    }
}
